import { fromJS, Record } from 'immutable';
import { isNumber } from 'lodash';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { AddressDataStatesEnum } from '../geolocation-data.data';
import { AddressCoordinates } from './address-coordinates.model';
import { AddressPosition } from './address-position.model';

export const ADDRESS_DATA_SCHEMA = Object.freeze({
  POSITION: AddressPosition,
  BREAKDOWN: null, // not used on the client
  STATE: AddressDataStatesEnum.no_match,
  VENDOR_ID: null, // not used on the client
});
const RECORD: any = generateSchema(ADDRESS_DATA_SCHEMA);
const KEYS: any = generateKeys(ADDRESS_DATA_SCHEMA);

export class AddressData extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    return setInModel(this, [
      {
        key: KEYS.POSITION,
        value: props.get(KEYS.POSITION)
          ? new AddressPosition(this.position)
          : null,
      },
    ]) as AddressData;
  }

  get position(): AddressPosition {
    return this.get(KEYS.POSITION);
  }

  get coordinates(): AddressCoordinates {
    return this.position && this.position.coordinates;
  }

  get state(): AddressDataStatesEnum {
    return this.get(KEYS.STATE);
  }

  hasCoordinates(): boolean {
    return (
      !!this.coordinates &&
      isNumber(this.coordinates.latitude) &&
      isNumber(this.coordinates.longitude)
    );
  }

  get latitude(): number {
    return this.hasCoordinates() && this.coordinates.latitude;
  }

  get longitude(): number {
    return this.hasCoordinates() && this.coordinates.longitude;
  }
}
